function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M6 8l1.333 1.333L10.667 6m4 2A6.667 6.667 0 111.333 8a6.667 6.667 0 0113.334 0z",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgCheckCircle = function SvgCheckCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    stroke: "#666A72"
  }, props), _ref);
};

export default SvgCheckCircle;